export default __webpack_public_path__ + "static/p4_en-35392c6046104e4813fecd4f69e5c657.png";